import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="relative mt-auto border-t-2 border-[#1a4a1a]/20 bg-white px-4 py-4 text-[#0a2f0a]">
      {/* Decorative pattern overlay */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 opacity-10"
        style={{
          backgroundImage:
            'url("data:image/svg+xml,%3Csvg width=\'80\' height=\'80\' viewBox=\'0 0 80 80\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M40 0L60 20L40 40L20 20z\' fill=\'%231a4a1a\' fill-opacity=\'0.05\'/%3E%3C/svg%3E")',
          backgroundSize: '80px 80px',
        }}
      />

      <div className="relative z-10 mx-auto grid max-w-[1200px] grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
        <div>
          <h4 className="relative pb-4 font-['Noto_Sans_Arabic',sans-serif] text-[0.9rem] font-bold text-[#0a2f0a]">
            Company Info
            <span className="absolute bottom-0 left-0 h-[2px] w-[60px] bg-gradient-to-r from-[#1a4a1a] to-transparent" />
          </h4>
          <ul className="mt-0 list-none p-0">
            <li>
              <Link
                className="relative inline-block py-2 text-[#0a2f0a] opacity-100 transition-all duration-300 ease-in-out before:mr-2 before:inline-block before:opacity-0 before:transition-all before:duration-300 before:ease-in-out before:content-['›'] before:-translate-x-2.5 hover:translate-x-[5px] hover:before:opacity-100 hover:before:translate-x-0"
                to="/about-us"
              >
                About Us
              </Link>
            </li>
            <li>
              <Link
                className="relative inline-block py-2 text-[#0a2f0a] opacity-100 transition-all duration-300 ease-in-out before:mr-2 before:inline-block before:opacity-0 before:transition-all before:duration-300 before:ease-in-out before:content-['›'] before:-translate-x-2.5 hover:translate-x-[5px] hover:before:opacity-100 hover:before:translate-x-0"
                to="/advisors"
              >
                Our Advisors
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="relative pb-4 font-['Noto_Sans_Arabic',sans-serif] text-[0.9rem] font-bold text-[#0a2f0a]">
            Follow Us
            <span className="absolute bottom-0 left-0 h-[2px] w-[60px] bg-gradient-to-r from-[#1a4a1a] to-transparent" />
          </h4>
          <ul className="mt-0 list-none p-0">
            <li>
              <a
                className="relative flex items-center gap-2 py-2 text-[#0a2f0a] opacity-100 transition-all duration-300 ease-in-out before:opacity-0 before:transition-all before:duration-300 before:ease-in-out before:content-['→'] hover:translate-x-[5px] hover:before:opacity-100 hover:before:mr-2"
                href="https://www.linkedin.com/company/halalcred/"
                target="_blank"
                rel="noopener noreferrer"
              >
                LinkedIn
              </a>
            </li>
            <li>
              <a
                className="relative flex items-center gap-2 py-2 text-[#0a2f0a] opacity-100 transition-all duration-300 ease-in-out before:opacity-0 before:transition-all before:duration-300 before:ease-in-out before:content-['→'] hover:translate-x-[5px] hover:before:opacity-100 hover:before:mr-2"
                href="https://www.facebook.com/profile.php?id=61575683030734"
                target="_blank"
                rel="noopener noreferrer"
              >
                Facebook
              </a>
            </li>
            <li>
              <a
                className="relative flex items-center gap-2 py-2 text-[#0a2f0a] opacity-100 transition-all duration-300 ease-in-out before:opacity-0 before:transition-all before:duration-300 before:ease-in-out before:content-['→'] hover:translate-x-[5px] hover:before:opacity-100 hover:before:mr-2"
                href="https://x.com/halalcred786"
                target="_blank"
                rel="noopener noreferrer"
              >
                Twitter
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="relative pb-4 font-['Noto_Sans_Arabic',sans-serif] text-[0.9rem] font-bold text-[#0a2f0a]">
            Legal
            <span className="absolute bottom-0 left-0 h-[2px] w-[60px] bg-gradient-to-r from-[#1a4a1a] to-transparent" />
          </h4>
          <ul className="mt-0 list-none p-0">
            <li>
              <Link
                className="relative inline-block py-2 text-[#0a2f0a] opacity-100 transition-all duration-300 ease-in-out before:mr-2 before:inline-block before:opacity-0 before:transition-all before:duration-300 before:ease-in-out before:content-['›'] before:-translate-x-2.5 hover:translate-x-[5px] hover:before:opacity-100 hover:before:translate-x-0"
                to="/privacy-policy"
              >
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link
                className="relative inline-block py-2 text-[#0a2f0a] opacity-100 transition-all duration-300 ease-in-out before:mr-2 before:inline-block before:opacity-0 before:transition-all before:duration-300 before:ease-in-out before:content-['›'] before:-translate-x-2.5 hover:translate-x-[5px] hover:before:opacity-100 hover:before:translate-x-0"
                to="/terms-and-conditions"
              >
                Terms and Conditions
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <hr className="relative z-10 mx-auto my-4 max-w-[1200px] border-0 border-t border-[#1a4a1a]/20" />

      <div className="relative z-10 mx-auto max-w-[1200px] space-y-2 pb-1">
        <p className="m-0 text-[0.95rem] font-semibold">© 2025 HalalCred LLC</p>
        <p className="m-0 border-l-[3px] border-[#1a4a1a]/35 pl-3 text-[0.95rem] leading-relaxed text-[#0a2f0a]">
          HalalCred is built in partnership with Craft3, a nationally recognized Community Development Financial Institution with deep expertise in Islamic financing and community lending.
        </p>
        <p className="m-0 text-[12px] leading-relaxed text-[#0a2f0a]/90">
          The content on this website is provided by HalalCred LLC for informational and communication purposes only. It does not constitute an offer, solicitation, or recommendation to invest in any financial product.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
